/*
 * @Author: liyifan 
 * @Date: 2024-09-14 10:48:05 
 * @Last Modified by: liyifan
 * @Last Modified time: 2024-11-04 16:45:39
 */
import { isMobile  } from '@utils/index.js'

$(document).ready(function() {
    if ($('.five-kwh-compare').length === 0) {
        return false
    }
    const { createApp } = Vue
    createApp({
        delimiters: ['${', '}'],
        data() {
            return {
                originList: window.fiveCompareJson,
                selectList: isMobile() ? window.fiveCompareJson.slice(0,2) : window.fiveCompareJson.slice(0,4), // 默认选择的产品
                selectSku: [],
                title: ''
            }
        },
        methods: {
            init() {
                this.selectSku = this.selectList.map(item => item.sku)
            },
            handleSelect(e, index) {
                const value = e.target.value
                const obj = this.selectList.find(item => item.sku === value)
                const skus = this.selectList.map(item => item.sku)
                if (value === skus[index]) return;
                // 存在表示选择了和以前相同的值
                if (obj) {
                    const j = skus.findIndex(item => item === value)
                    // 替换数组中元素的位置
                    let jObj = this.selectList[j]
                    this.selectList[j] = this.selectList[index]
                    this.selectList[index] = jObj
                    this.selectSku = this.selectList.map(item => item.sku)
                } else {
                    this.selectList[index] = this.originList.find(item => item.sku === value)
                    this.selectSku[index] = value
                }
            }
        },
        mounted() {
            this.title = $('.five-kwh-compare .five-compare-title .title').text().trim()
            this.init()
        }
    }).mount('.five-kwh-compare')
})